import { useEffect, useState } from "react";

import "./stylesEditNoteModal.css";

import { Input } from "antd";
import { CloseOutlined } from "@ant-design/icons";

function EditNoteModal({ handleCancel, handleNotesChange, editNote }) {
  const [note, setNote] = useState({
    id: editNote.id,
    note: editNote.note,
    name: editNote.name,
    time: editNote.time,
  });

  const handleNoteChange = (e) => {
    setNote({
      ...note,
      note: e.target.value,
    });
  };

  const handleClose = () => {
    handleCancel();
  };

  useEffect(() => {
    setNote({
      id: editNote.id,
      note: editNote.note,
      name: editNote.name,
      time: editNote.time,
    });
  }, [editNote]);
  return (
    <div className="suspend-modal-container">
      <div className="modal-header">
        <div className="modal-header-title">
          <h2 className="modal-title">Edit Note</h2>
        </div>
        <CloseOutlined onClick={handleClose} className="close-icon" />
      </div>

      <div className="divider" />

      <div className="modal-content">
        <div className="transaction-info-item">
          <Input.TextArea
            type="text"
            value={note.note}
            maxLength={255}
            rows={3}
            placeholder="Leave a comment"
            onChange={handleNoteChange}
          />
          <span className="max-length">{note.note.length}/255</span>
        </div>
      </div>

      <div className="divider" />
      <div className="modal-footer">
        <div className="buttons">
          <button className="cancel-button" onClick={handleClose}>
            Close
          </button>
          <button
            className="save-button"
            onClick={() => {
              handleNotesChange(note, true);
              handleClose();
            }}
          >
            Save
          </button>
        </div>
      </div>
    </div>
  );
}

export default EditNoteModal;
